import { Link } from 'react-router-dom';
import { FileText, Mail, MapPin, Phone, Shield } from 'lucide-react';

export const MentionsLegales = () => {
  return (
    <div data-testid="mentions-legales-page">
      {/* Hero */}
      <section className="bg-[#0B1F3A] py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <FileText className="mx-auto text-[#C8A75A] mb-4" size={40} />
          <h1 className="font-serif-heading text-4xl font-semibold text-white mb-4">
            Mentions légales
          </h1>
          <div className="w-16 h-0.5 bg-[#C8A75A] mx-auto"></div>
        </div>
      </section>

      {/* Contenu */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12 prose prose-lg">
          
          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4">
              1. Éditeur du site
            </h2>
            <div className="bg-[#F5F5F5] p-6 border-l-4 border-[#C8A75A]">
              <p className="text-[#4A4A4A] mb-2"><strong className="text-[#0B1F3A]">Institut BIA</strong></p>
              <p className="text-[#4A4A4A] mb-2">Centre de Formation par Apprentissage</p>
              <p className="text-[#4A4A4A] mb-4">Saint-Denis (93) - Île-de-France</p>
              <p className="text-[#4A4A4A] flex items-center gap-2 mb-2">
                <Phone size={16} className="text-[#C8A75A]" /> +33 1 87 66 30 91
              </p>
              <p className="text-[#4A4A4A] flex items-center gap-2">
                <Mail size={16} className="text-[#C8A75A]" /> contact@institut-bia.fr
              </p>
            </div>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4">
              2. Gestion du site
            </h2>
            <div className="bg-[#F5F5F5] p-6 border-l-4 border-[#C8A75A]">
              <p className="text-[#4A4A4A] mb-3">
                Pour toute question relative à la gestion du site (contenu, technique, mise à jour) :
              </p>
              <p className="text-[#4A4A4A] flex items-center gap-2">
                <Mail size={16} className="text-[#C8A75A]" /> 
                <a href="mailto:postmaster@institut-bia.fr" className="text-[#C8A75A] hover:underline">
                  postmaster@institut-bia.fr
                </a>
              </p>
            </div>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4">
              3. Hébergement
            </h2>
            <p className="text-[#4A4A4A]">
              Le site est hébergé par la plateforme Emergent.
            </p>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4">
              4. Propriété intellectuelle
            </h2>
            <p className="text-[#4A4A4A] mb-3">
              L'ensemble du contenu de ce site (textes, images, logos, graphismes, etc.) est la propriété 
              exclusive de l'Institut BIA ou de ses partenaires. Toute reproduction, représentation, 
              modification ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite.
            </p>
            <p className="text-[#4A4A4A]">
              La marque "Institut BIA" et le logo associé sont des marques déposées.
            </p>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4">
              5. Certification
            </h2>
            <ul className="text-[#4A4A4A] space-y-2">
              <li>• CFA déclaré DREETS Île-de-France</li>
              <li>• Titre Professionnel Négociateur Technico-Commercial - RNCP39063 Niveau 5</li>
              <li>• Certification Qualiopi en cours</li>
            </ul>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4">
              6. Responsabilité
            </h2>
            <p className="text-[#4A4A4A]">
              L'Institut BIA s'efforce de fournir sur son site des informations aussi précises que possible. 
              Toutefois, il ne pourra être tenu responsable des omissions, inexactitudes ou carences dans 
              la mise à jour, qu'elles soient de son fait ou du fait de tiers partenaires.
            </p>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4">
              7. Liens hypertextes
            </h2>
            <p className="text-[#4A4A4A]">
              Le site peut contenir des liens vers d'autres sites internet. L'Institut BIA ne peut être 
              tenu responsable du contenu de ces sites tiers.
            </p>
          </div>

          <div className="mb-10">
            <h2 className="font-serif-heading text-2xl font-semibold text-[#0B1F3A] mb-4">
              8. Droit applicable
            </h2>
            <p className="text-[#4A4A4A]">
              Les présentes mentions légales sont soumises au droit français. En cas de litige, les 
              tribunaux français seront seuls compétents.
            </p>
          </div>

          <div className="mt-12 p-6 bg-[#0B1F3A] text-white">
            <div className="flex items-start gap-3">
              <Shield className="text-[#C8A75A] flex-shrink-0 mt-1" size={24} />
              <div>
                <h3 className="font-semibold mb-2">Protection des données personnelles</h3>
                <p className="text-[#F5F5F5]/80 text-sm mb-2">
                  Consultez notre politique de confidentialité pour connaître vos droits (RGPD).
                </p>
                <Link to="/politique-confidentialite" className="text-[#C8A75A] hover:underline text-sm">
                  → Politique de confidentialité
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MentionsLegales;
